/**
 * Alpine.js Modal and MailChimp AJAX Integration
 *
 * This script handles the integration between Alpine.js and MailChimp
 * for a seamless signup process that automatically opens on page load.
 */

// console.log('alpine-mailchimp-ajax.js file loaded');

// Define modalHandler globally so Alpine can find it
window.modalHandler = function modalHandler() {
   //  console.log('modalHandler function called');

   return {
      isOpen: false,
      submitted: false,
      loading: false,
      error: null,
      formData: {
         email: "",
         firstName: "",
         lastName: "",
      },

      // Open the modal
      open() {
         // Check if we should show the modal based on cookies
         if (this.shouldSuppressModal()) {
            return;
         }

         this.isOpen = true;
         // Prevent body scrolling when modal is open
         document.body.style.overflow = "hidden";
      },

      // Close the modal
      close() {
         // console.log('Close method called'); // Debug
         this.isOpen = false;
         // Re-enable body scrolling
         document.body.style.overflow = "";

         // For requirement #3: Set cookie to not show for 5 days
         this.setCookie("modalClosed", "true", 5);
      },

      // Handle form submission
      submitForm() {
         // Validate the form before submitting
         if (!this.validateForm()) {
            return; // Stop submission if validation fails
         }

         this.loading = true;
         this.error = null;

         // Use fetch to submit the form data
         fetch("mailchimp-proxy.php", {
            method: "POST",
            headers: {
               "Content-Type": "application/json",
            },
            body: JSON.stringify(this.formData),
         })
            .then((response) => response.json())
            .then((data) => {
               this.loading = false;

               // Handle the response
               if (
                  data.id ||
                  data.status === "pending" ||
                  data.status === "subscribed"
               ) {
                  // Success - show confirmation
                  this.submitted = true;

                  // For requirement #3: Set cookie to not show for 21 days after signup
                  this.setCookie("modalSignup", "true", 21);
               } else {
                  // Handle errors from MailChimp
                  let errorMessage =
                     "There was an error processing your subscription.";

                  // MailChimp returns specific error messages we can display
                  if (data.title === "Member Exists") {
                     errorMessage =
                        "This email is already subscribed to our list.";
                  } else if (data.detail) {
                     errorMessage = data.detail;
                  }

                  this.error = errorMessage;
               }
            })
            .catch((error) => {
               console.error("Error:", error);
               this.loading = false;
               this.error =
                  "There was an error connecting to the server. Please try again.";
            });
      },

      // Validation method
      validateForm() {
         // Clear any previous errors
         this.error = null;

         // Check if email is empty
         if (!this.formData.email || this.formData.email.trim() === "") {
            this.error = "Please enter your email address.";
            return false;
         }

         // Check if email format is valid
         const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
         if (!emailRegex.test(this.formData.email)) {
            this.error = "Please enter a valid email address.";
            return false;
         }

         return true; // All validation passed
      },

      // Helper method to set cookies (for requirement #3)
      setCookie(name, value, days) {
         // console.log('setCookie called with:', name, value, days); // Debug
         const date = new Date();
         date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
         const expires = "; expires=" + date.toUTCString();
         const cookieString = name + "=" + value + expires + "; path=/";
         // console.log('Cookie string:', cookieString); // Debug
         document.cookie = cookieString;
         // console.log('Document cookie after setting:', document.cookie); // Debug
      },

      // Helper method to check if modal should be suppressed
      shouldSuppressModal() {
         // Don't show if user closed modal in last 5 days
         if (document.cookie.indexOf("modalClosed=true") !== -1) {
            return true;
         }

         // Don't show if user signed up in last 21 days
         if (document.cookie.indexOf("modalSignup=true") !== -1) {
            return true;
         }

         // Otherwise, show the modal
         return false;
      },
   };
};

document.addEventListener("DOMContentLoaded", function () {
   // The modal will now auto-open through x-init in the HTML
   // This is kept for any additional initialization needed
});

/**
 * Set up additional functionality if needed
 * This function is kept for future customizations
 */
function setupAdditionalFunctionality() {
   // This function is kept as a placeholder for any additional
   // functionality that might be needed in the future
}

/**
 * Check if the modal should be shown after a delay
 * This can be used if you want to show the modal after a few seconds
 * instead of immediately on page load
 */
function showModalWithDelay(delayMs) {
   setTimeout(() => {
      // This will trigger the modal to open if it's not already open
      // and if it's not suppressed by cookies
      window.dispatchEvent(new CustomEvent("open-modal"));
   }, delayMs);
}
